<script>
export default {
    props: {
        element: {
            type: [String],
            required: false,
            default: 'div'
        },
        padding: {
            type: [Boolean],
            required: false,
            default: false
        }
    },
    data() {
        return {
            attrs: {
                class: this.padding ? 'wrapper wrapper--padding' : 'wrapper'
            }
        }
    },
    render(createElement, context) {
        return createElement(
            this.element,
            {
                attrs: this.attrs
            },
            this.$slots.default
        )
    }
}
</script>

<style lang="scss">
.wrapper {
    width: calc(100% - 4rem);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;

    &--padding {
        padding-top: 2rem;
        padding-bottom: 2rem;
    }

    @media (max-width: 992px) {
        width: calc(100% - 1rem);

        &--padding {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        }
    }
}
</style>

